// Pure, framework-free helpers backing the SuggestAutocomplete bridge component.
// Kept out of the React component so they can be unit tested in the project's
// `node` Vitest environment (no jsdom / @testing-library — components cannot be
// rendered). SuggestAutocomplete is a FREE-TEXT combobox: the value IS the typed
// string. These helpers own the suggestion filtering and the typed-text /
// selected-suggestion → value mapping; the component is a thin wiring layer over
// them and the presentation-only `Autocomplete` primitive.


/**
 * Client-side filter of suggestion `options` against the typed `value`. Plain
 * case-insensitive substring match on each option's label. A null/undefined
 * value is treated as empty and matches everything. Unlike the strict
 * OptionAutocomplete there is no "selected option" concept — the value is just
 * the current text, so an empty value shows the full suggestion list (and the
 * field shows its placeholder).
 */
function filterSuggestions(options, value) {
  const needle = String(value ?? '').toLowerCase();
  return options.filter((o) => String(o.label ?? '').toLowerCase().includes(needle));
}


/** The value emitted when the user types: the raw text becomes the value. */
function valueFromTyped(text) {
  return text ?? '';
}


/** The value emitted when a suggestion row is selected: its label fills the text. */
function valueFromSuggestion(option) {
  return option?.label ?? '';
}


export {
  filterSuggestions,
  valueFromSuggestion,
  valueFromTyped,
};
